// Define an object containing API endpoints for a specific feature (in this case, authentication)
const API_ENDPOINTS = {
	auth: {
			REGISTER: '/auth/register'
	}
}

// Export the endpoint object for use in other modules
export default API_ENDPOINTS
